import { useState } from 'react';

import { Avatar, Button, Text, TextField } from '@praetoid/ui';
import { createFileRoute, useRouter } from '@tanstack/react-router';

import {
	getListOrganizationsQueryKey,
	getListPraetorsQueryKey,
	getUserQueryKey,
	useCreateOrganization,
	useUser
} from '@praetoid/client';

import { queryClient } from '~/lib/queryClient';

export const Route = createFileRoute('/_onboarding/orgs/onboarding')({
	component: RouteComponent
});

function RouteComponent() {
	const { data: user } = useUser();
	const router = useRouter();

	const [firstName, setFirstName] = useState('Jane');
	const [lastName, setLastName] = useState('Doe');
	const [organizationName, setOrganizationName] = useState('Doggo Inc');

	const { mutate: createOrganization } = useCreateOrganization({
		mutation: {
			onSuccess: async () => {
				await queryClient.invalidateQueries({ queryKey: getListOrganizationsQueryKey() });
				await queryClient.invalidateQueries({ queryKey: getListPraetorsQueryKey() });
				await queryClient.refetchQueries({ queryKey: getUserQueryKey() });
				await router.navigate({ to: '/' });
			}
		}
	});

	return (
		<div className="ui-gradient grid h-screen grid-cols-[1fr_440px_1fr] grid-rows-1 p-4">
			<div
				className="relative flex h-full items-center justify-center"
				style={{ gridColumnStart: 2 }}
			>
				<div className="bg-panel flex w-full flex-col items-end gap-6 rounded-md border p-12">
					<div className="flex flex-col gap-4">
						<div className="flex flex-row items-center gap-2">
							<Avatar fallback={user?.email?.charAt(0) ?? '?'} />

							<Text size="2">{user?.email}</Text>
						</div>

						<div className="flex flex-row gap-4">
							<div className="flex flex-col gap-1">
								<Text size="2" weight="medium">
									First name
								</Text>

								<TextField.Root
									placeholder="Jane"
									size="2"
									variant="surface"
									defaultValue={firstName}
									onChange={(e) => setFirstName(e.target.value)}
								/>
							</div>

							<div className="flex flex-col gap-1">
								<Text size="2" weight="medium">
									Last name
								</Text>
								<TextField.Root
									placeholder="Doe"
									size="2"
									variant="surface"
									defaultValue={lastName}
									onChange={(e) => setLastName(e.target.value)}
								/>
							</div>
						</div>

						<div className="flex flex-col gap-1">
							<Text size="2" weight="medium">
								Organization name
							</Text>
							<TextField.Root
								placeholder="Doe"
								size="2"
								variant="surface"
								defaultValue={organizationName}
								onChange={(e) => setOrganizationName(e.target.value)}
							/>
						</div>
					</div>

					<Button
						color="accent"
						className="border-accentA-6 border"
						variant="soft"
						onClick={() =>
							createOrganization({
								data: { organization: { name: organizationName } }
							})
						}
					>
						Continue
					</Button>
				</div>
			</div>
		</div>
	);
}
